
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UpdateUserCompanyForm from './updateUserCompanyForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class UpdateUserCompany extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Select Company',
                content: <UpdateUserCompanyForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default UpdateUserCompany
